<template>
  <div>
    <div class="card" v-loading="working" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">{{title}}</h4>
        <p v-if="description" class="category">{{description}}</p>
      </div>
      <div class="card-content">
        <div class="form-horizontal" data-vv-scope="add-user-form">
          <dynamic-input label="Email" name="email" :validations="{required: true, email:true}" v-model="lowercaseEmail" />
          <dynamic-input label="First name" name="firstname" :validations="{required: true}" v-model="firstname" />
          <dynamic-input label="Last name" name="lastname" :validations="{required: true}" v-model="lastname" />
          <dynamic-input label="Phone" name="phone" :validations="{required: true}" v-model="phone" />

          <div class="form-group">
            <label class="col-sm-2 control-label">Admin</label>
            <div class="col-sm-10">
              <p class="form-control-static"><p-switch v-model="admin" on-text="Yes" off-text="No"></p-switch></p>
              <span class="help-block">Admin users will be able to view and change company details as well as add more users.</span>
            </div>
          </div>
          <div v-if="assignableCustomRoles && assignableCustomRoles.length > 0" class="form-group">
            <label class="col-sm-2 control-label">{{customRolesLabel}}</label>
            <div class="col-sm-10">
              <p class="form-control-static">
                <el-select multiple
                  v-model="roles"
                  :clearable="true"
                  placeholder="None"
                  style="z-index: 1000 !important;">
                  <el-option v-for="role in assignableCustomRoles" :key="role" :value="role" :label="role" />
                </el-select>
              </p>
              <span class="help-block">Assign a {{customRolesLabel}} to manage a users permissions.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button v-if="!self" @click="$emit('close')" class="btn btn-wd "><span class="btn-label"><i class="fa fa-times"></i></span>&nbsp;Cancel</button>
          <button @click="saveUser" class="btn btn-fill btn-wd pull-right" v-bind:disabled="!savable" v-bind:class="{'btn-disabled': !savable}"><span class="btn-label"><i class="fa fa-floppy-o"></i></span>&nbsp;Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DynamicInput from 'src/views/Verifications/components/DynamicInput'
  import PSwitch from 'src/components/Switch.vue'
  
  export default {
    name: 'register-user-card',
    components: {
      DynamicInput,
      PSwitch
    },
    props: {
      title: {type: String, default: "Account" },
      description: {type: String, default: "Your account details and settings"},
      companyId: {type: Number},
      self: {type: Boolean, default: true},
      customRolesLabel: {type: String, default: "Roles"},
      assignableCustomRoles: {type: Array, default: function(){return []}}
    },
    data () {
      return {
        email: null,
        firstname: null,
        lastname: null,
        phone: null,
        companyName: null,
        saving: false,
        admin: false,
        roles: []
      }
    },
    computed: {
      lowercaseEmail: {
        get() {
          return this.email ? this.email.toLowerCase() : '';
        },
        set(value) {
          this.email = value.toLowerCase();
        }
      },
      working() {
        return this.saving
      },
      savable() {
        return !this.saving && !this.$validator.errors.any()
      }
    },
    methods: {
      saveUser() {
        this.$validator.validateAll().then(result => {
          if(result) {
            this.saving = true
            this.doSave()
              .then(response => {
                this.$snotify.success(this.title + " added", "Success")
                this.$emit('saved')
                this.saving = false
              })
              .catch(error => {
                console.log(error)
                this.saving = false
              })
          }
        })
      },
      doSave() {
        var addRequest = {
          username: this.email,
          firstname: this.firstname,
          lastname: this.lastname,
          phone: this.phone,
          marketing: this.marketing,
          admin: this.admin,
          customRoles: this.roles
        }
        return this.self ? this.$api.updateAccount(addRequest) : this.$api.addUser(addRequest)
      }
    }
  }
</script>